import { useCallback, useEffect, useState } from "react";
import { fetchFastApi } from "../api/fastapi";
import { ApprovalRequest, ApprovalRequestSchema } from "../models/approval";

export const useApprovalRequestForEntity = (
  entityType: string | null,
  entityId: string | null,
) => {
  const [loading, setLoading] = useState(false);
  const [request, setRequest] = useState<ApprovalRequest | null>(null);

  const fetchRequest = useCallback(async () => {
    if (!entityType || !entityId) {
      setRequest(null);
      return;
    }

    setLoading(true);
    try {
      const data = await fetchFastApi({
        path: `/approvals/requests/entity/${entityType}/${entityId}`,
        method: "GET",
      });

      if (data.request) {
        setRequest(ApprovalRequestSchema.parse(data.request));
      } else {
        setRequest(null);
      }
    } catch {
      setRequest(null);
    } finally {
      setLoading(false);
    }
  }, [entityType, entityId]);

  useEffect(() => {
    fetchRequest();
  }, [fetchRequest]);

  return {
    loading,
    request,
    refetch: fetchRequest,
  };
};
